const PURE_URL = process.env.REACT_APP_PURE_URL;

export default PURE_URL;
